import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the AbsPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'abs',
})
export class AbsPipe implements PipeTransform {
  transform(input) {
    if (isNaN(input) || input === 0) {
      return '-';
    } else {
      return Math.abs(input);
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/pipes/abs/abs.ts